<template src="./passwordReset.html"></template>

<script>
import { save_newPassword } from "@/api/api.auth.js";

export default {
    data: () => ({
        e1: true,
        e2: true,
        alertElaborazione: "",
        tipo: "success",

        cred: {
            passwordAttuale: "",
            password: "",
            code: "",
        },

        attesa: false,
        reset: false,
    }),

    methods: {
        async submit() {
            // Reset messaggi
            this.$toast.close();

            // Validazione
            if (this.$refs.formReset.validate() == false) {
                return;
            }

            // Controllo presenza codice
            if (!this.checkCode()) return;

            // Reset psw
            this.attesa = true;
            this.cred.code = this.$route.query.code;
            save_newPassword(this.cred)
                .then((res) => {
                    this.tipo = "success";
                    this.alertElaborazione =
                        "Operazione completata. Premi il tasto 'Indietro' per tornare al login.";

                    this.disabilitaBtn = false;
                    this.OK = true;
                })
                .catch((err) => {
                    console.log("pwdreset.vue " + err);

                    this.disabilitaBtn = false;
                    this.tipo = "warning";
                    this.alertElaborazione = err.response
                        ? err.response.data.Message
                        : err.message;
                });

            this.attesa = false;
        },

        checkCode() {
            if (this.$route.query.code && this.$route.query.code.length > 0) {
                return true;
            }

            return false;
        },
    },

    mounted() {
        this.reset = this.checkCode();
    },
};
</script>